export enum MfaTwoFactorMethod {
	NotSet = 0,
	Email = 1,
	SMS = 2
}
